import React, { useState, useEffect } from 'react';
import './App.css';
import Login from './components/Login';
import Dashboard from './components/Dashboard';

const API_URL = 'https://mega-brasil-api.cejusc.workers.dev';

function App() {
  const [combination, setCombination] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [user, setUser] = useState(null);
  const [showLogin, setShowLogin] = useState(false);
  const [showDashboard, setShowDashboard] = useState(false);

  useEffect(() => {
    // Verificar se há usuário logado
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');
    if (token && userData) {
      setUser(JSON.parse(userData));
    }
  }, []);

  const getCombination = async () => {
    setLoading(true);
    setError(null);
    try {
      const headers = {};
      const token = localStorage.getItem('token');
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }
      
      const response = await fetch(`${API_URL}/api/combination/get`, { headers });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      setCombination(data.combination);
    } catch (error) {
      console.error('Erro ao obter combinação:', error);
      setError('Erro ao conectar com a API. Tente novamente.');
      // Fallback: gerar números localmente
      const fallback = Array.from({length: 6}, () => Math.floor(Math.random() * 60) + 1).sort((a, b) => a - b);
      setCombination(fallback);
    }
    setLoading(false);
  };

  const handleLogin = (userData) => {
    setUser(userData);
    setShowLogin(false);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
    setShowDashboard(false);
  };

  if (showDashboard && user) {
    return <Dashboard user={user} onLogout={handleLogout} />;
  }

  return (
    <div className="App">
      <header className="App-header">
        <h1>🎲 Mega Brasil</h1>
        <p className="subtitle">Distribuição Inteligente de Combinações</p>
        <p>Aumentando as chances do Brasil ganhar na Mega Sena</p>
        
        <div className="header-actions">
          {user ? (
            <div className="user-menu">
              <span>Olá, {user.name}!</span>
              <button onClick={() => setShowDashboard(true)} className="btn-dashboard">
                📊 Dashboard
              </button>
              <button onClick={handleLogout} className="btn-logout">
                Sair
              </button>
            </div>
          ) : (
            <button onClick={() => setShowLogin(true)} className="btn-login">
              👤 Entrar / Cadastrar
            </button>
          )}
        </div>
      </header>

      <main className="main-content">
        <section className="hero">
          <h2>Sua Combinação Única</h2>
          <p>Cada combinação distribuída é única até o próximo sorteio!</p>
          
          {error && (
            <div className="error-message">
              <p>⚠️ {error}</p>
            </div>
          )}
          
          {!combination ? (
            <button className="btn-primary" onClick={getCombination} disabled={loading}>
              {loading ? '🎯 Gerando...' : '🎲 Obter Minha Combinação'}
            </button>
          ) : (
            <div className="combination-display">
              <h3>Sua combinação única:</h3>
              <div className="numbers">
                {combination.map((num, idx) => (
                  <span key={idx} className="number-ball">{num}</span>
                ))}
              </div>
              <p>✨ Boa sorte! Esta combinação é exclusivamente sua!</p>
              <button className="btn-secondary" onClick={() => {setCombination(null); setError(null);}}>
                🔄 Gerar Nova Combinação
              </button>
            </div>
          )}
        </section>

        <section className="info">
          <h2>📊 Sobre o Projeto</h2>
          <div className="info-grid">
            <div className="info-card">
              <h3>🎯 Objetivo</h3>
              <p>Distribuir combinações únicas para maximizar as chances de haver ganhadores na Mega Sena, contribuindo para uma distribuição mais equitativa da riqueza no Brasil.</p>
            </div>
            <div className="info-card">
              <h3>🧮 Como Funciona</h3>
              <p>Cada IP recebe uma combinação única por sorteio, evitando duplicatas e aumentando a cobertura estatística dos números possíveis.</p>
            </div>
            <div className="info-card">
              <h3>🚀 Tecnologia</h3>
              <p>Desenvolvido com React e Cloudflare Workers, usando análises estatísticas avançadas e algoritmos de distribuição inteligente.</p>
            </div>
          </div>
        </section>
      </main>

      <footer className="footer">
        <p>© 2024 Mega Brasil - Por um Brasil com mais vencedores! 🇧🇷</p>
        <p>API Status: <span className="status-indicator">🟢 Online</span></p>
      </footer>

      {showLogin && (
        <Login 
          onLogin={handleLogin} 
          onClose={() => setShowLogin(false)} 
        />
      )}
    </div>
  );
}

export default App;